import { render, staticRenderFns } from "./StartAnimation.vue?vue&type=template&id=14d23eea&scoped=true"
import script from "./StartAnimation.vue?vue&type=script&lang=js"
export * from "./StartAnimation.vue?vue&type=script&lang=js"
import style0 from "./StartAnimation.vue?vue&type=style&index=0&id=14d23eea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d23eea",
  null
  
)

export default component.exports